import { Navigate, useLocation } from "react-router-dom";
import { useSession } from "@/auth/session";
import { getFirstAllowedPath } from "@/auth/module-access";

export function RequireModule({
  moduleCode,
  children,
}: {
  moduleCode: string | string[];
  children: React.ReactNode;
}) {
  const location = useLocation();
  const { isAuthenticated, isLoading, allowedModules, hasModule } = useSession();

  if (!isAuthenticated) {
    return <Navigate to="/login" replace />;
  }

  if (isLoading) {
    return (
      <div className="min-h-[40vh] flex items-center justify-center text-sm text-gray-500">
        Cargando permisos...
      </div>
    );
  }

  const hasAccess = Array.isArray(moduleCode)
    ? moduleCode.some((m) => hasModule(m))
    : hasModule(moduleCode);

  if (hasAccess) {
    return <>{children}</>;
  }

  const fallback = getFirstAllowedPath(allowedModules);
  if (location.pathname === fallback) {
    return (
      <div className="rounded-xl border border-amber-200 bg-amber-50 p-4 text-sm text-amber-700">
        Tu usuario no tiene permisos para acceder a este módulo.
      </div>
    );
  }

  return <Navigate to={fallback} replace />;
}
